import styles from '../../../../stylesheets/variables.scss';

export const selectSx = {
    container: {
        width: '100%',
        '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
                borderColor: styles.jungleGreen,
            },
            '&.Mui-focused fieldset': {
                borderColor: styles.jungleGreen,
            },
        },
    },
    label: {
        top: '-7px',
        '&.MuiInputLabel-filled': {
            top: '0px',
        },
        '&.Mui-focused': {
            color: styles.jungleGreen,
            top: '0px',
        },
    },
    menuItem: {
        '&.Mui-selected': {
            backgroundColor: styles.greenSelected,
        },
        '&.Mui-selected:focus': {
            backgroundColor: styles.greenSelected,
        },
        '&.Mui-selected:hover': {
            backgroundColor: styles.greenSelectedDark,
        },
    },
};
